const noOutline = {
  "&:focus": {
    outline: "none",
  },
};

export default noOutline;
